import * as React from "react";

const ProductListingsCold: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g fill="none" fillRule="evenodd" transform="translate(2.125 2.375)">
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M2.25000054,0 L0.33430481,4.5 L7.3125,4.5 L7.3125,0 L2.25000054,0 Z M8.4375,4.5 L15.2485992,4.5 L13.5,0 L8.4375,0 L8.4375,4.5 Z M15.75,5.625 L0,5.625 L0,15.75 L15.75,15.75 L15.75,5.625 Z"
                />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M2.09531271,4.5 L3.34687543,1.6875 L7.03125054,1.6875 L7.03125054,4.5 L2.09531271,4.5 L2.09531271,4.5 Z M8.71875054,4.5 L8.71875054,1.6875 L12.4031251,1.6875 L13.6546878,4.5 L8.71875054,4.5 Z M14.0625005,6.1875 L14.0625005,14.0625 L1.68750054,14.0625 L1.68750054,6.1875 L14.0625005,6.1875 Z M13.5000005,0 L2.25000054,0 L5.36441803e-07,5.0625 L5.36441803e-07,14.0625 L5.36441803e-07,15.75 L1.68750054,15.75 L14.0625005,15.75 L15.7500005,15.75 L15.7500005,14.0625 L15.7500005,5.0625 L13.5000005,0 Z"
                />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M8.25,7.75 L8.249,9.221 L9.28921356,8.18045635 L9.81954365,8.71078644 L8.781,9.749 L10.25,9.75 L10.25,10.5 L8.779,10.499 L9.81954365,11.5392136 L9.28921356,12.0695436 L8.249,11.029 L8.25,12.5 L7.5,12.5 L7.499,11.031 L6.46078644,12.0695436 L5.93045635,11.5392136 L6.971,10.499 L5.5,10.5 L5.5,9.75 L6.969,9.749 L5.93045635,8.71078644 L6.46078644,8.18045635 L7.499,9.219 L7.5,7.75 L8.25,7.75 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ProductListingsCold);
